import React from 'react';
import { Layout } from '~common/Layout';
import { StandardCard } from '../src/common/UI';
import { ScheduleCalendar } from '../src/features/calendar';

export default function Schedule() {
  return (
    <Layout>
      <StandardCard cardClassName="bg-opacity-90 -m-4 md:m-0">
        <ScheduleCalendar />
      </StandardCard>
    </Layout>
  );
}
